import React from 'react';
import styled from 'styled-components';
import { TextButton } from 'components/v2/buttons';
import { ReactComponent as MessageIcon } from 'images/v2/icons/svg/fill/svg/message.svg';
import { useShowEPDCommentLogButton } from 'hooks/useEPDCommentLogVisibility';
import { EpdLinks } from 'routes/EpdRoutes';

const CommentLogButton: React.FunctionComponent<{ epdId: string }> = ({ epdId }) => {
  const showButton = useShowEPDCommentLogButton(epdId);

  if (!showButton) {
    return null;
  }

  return (
    <TextButton
      type="button"
      style={{ fontSize: 14, fontWeight: 500 }}
      text
      label="Comment log"
      icon={<StyledMessageIcon />}
      onClick={() => window.open(EpdLinks.epdCommentLog(epdId), '_blank', 'noopener,noreferrer')}
    />
  );
};

const StyledMessageIcon = styled(MessageIcon)`
  display: block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  color: ${(props) => props.theme.colors.primaryOrange};

  button:hover & {
    color: ${(props) => props.theme.colors.elementsButtonHover};
  }
`;

export default CommentLogButton;


